export default "__VITE_ASSET__D1x4XHMf__"